// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__uYieU","section":"Footer_section__sc72G","line":"Footer_line__ndNse","items":"Footer_items__4ZjhF","link":"Footer_link__aa3mS"};